import { useContext, useEffect, useState } from "react";
import BaseUrl from "../../../utils/BaseUrl";
import CustomerStyle from "../../../utils/customerStyle";
import ContentPage from "../../Content";
import separateNumber from "../../../utils/separateur";
import axios from "axios";
import DataTable from "react-data-table-component";
import ExportExcel from "../../../utils/ExcelExport";
import DetailSitesPage from "./detail_sites_page";
import { UserContext } from "../../../utils/User_check";
import { useNavigate } from "react-router-dom";
import can from "../../../utils/Can";

const url = BaseUrl();
const customerStyle = CustomerStyle();
function DegradationFondRoulementPage(){
      const [itemsList,setItemsList] = useState([]);
      const [itemsListFilter,setItemsListFilter] = useState([]);
      const [loading, setLoading] = useState(false);
      const [newComponent,setNewComponent] = useState('list');
      const [item,setItem] = useState(null);



    const {user,role, permissions} = useContext(UserContext);
    const navigate = useNavigate();
    useEffect(()=>{
      if(user && permissions && !can(permissions,'SUIVI DES DEGRADATIONS')){
          navigate('/page-no-found');
      }
  },[user]);

    useEffect(()=>{
        fetchItemsList();
      },[]);
      const fetchItemsList = async ()=>{
        setLoading(true);
        try {
            axios.get(url.base+'/suivis_degradation_fond_de_roulement',{
                headers:{
                    'Content-Type':'application/json',
                    "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                    
                },
            }).then((resp)=>{
    
                if(resp.status == 200){
                    setItemsList(resp.data);
                    setItemsListFilter(resp.data);
                }
                setLoading(false);
            })
        } catch (error) {
            setLoading(false);
        }
    }
    
    const handleFilter=(event)=>{
      const datas = itemsListFilter?.filter(row => row.Site.toLowerCase().includes(event.target.value.toLowerCase() ) || row.SecteurCommercial.toLowerCase().includes(event.target.value.toLowerCase()) || row.EstPrincipal.toLowerCase().includes(event.target.value.toLowerCase()) || row.NumeroMarchandGesite.toLowerCase().includes(event.target.value.toLowerCase())  )  ;
      setItemsList(datas);
    }


    return (
        <>
            <ContentPage>
            <div class="page-header flex-wrap">
                    <div class="header-right d-flex flex-wrap mt-md-2 mt-lg-0">
                        <div class="d-flex align-items-center">
                        <a href="#">
                            <p class="m-0 pr-3 fs-4">Page</p>
                        </a>
                        <a class="pl-3 mr-4" href="#">
                            <p class="m-0 fs-4">Listes des dégradations</p>
                        </a>
                        </div>
                        
                    </div>

              
            </div>

            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
             
                  <div class="card-body">
                        <h4 class="card-title">LISTE DES DEGRADATIONS</h4>
                              <div class="container-scroller" >




            {loading &&
                <div class="text-center">
                <div class="spinner-border" role="status">
                  {/* <span class="visually-hidden">Loading...</span> */}
                </div>
              </div>
                }
                {!loading && itemsList.map((item, i) => (
                  <div className="accordion p-3" id={`accordionExample${i}`} key={i}>
                    <div className="accordion-item p-3">
                      <h2 className="accordion-header" id={`headingOne${i}`}>
                        <button
                          className="accordion-button fw-bold"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapseOne${i}`}
                          aria-expanded="false"
                          aria-controls={`collapseOne${i}`}
                        >
                          {i + 1} - NOM DU SITE : {item.NomGeSite}
                        </button>
                        <p className="mt-2">
                          <strong>Total du site :</strong> <b className="text-danger">{parseInt(item.MontantTotal).toLocaleString()}</b>  FCFA |
                          <strong> Remboursé :</strong> <b className="text-danger">{parseInt(item.RemborseTotal).toLocaleString()}</b> FCFA |
                          <strong> Reste :</strong> <b className="text-danger">{parseInt(item.ResteTotal).toLocaleString()}</b> FCFA
                        </p>

                      </h2>
                      
                      <div
                        id={`collapseOne${i}`}
                        className="accordion-collapse collapse"
                        aria-labelledby={`headingOne${i}`}
                        data-bs-parent={`#accordionExample${i}`}
                      >
                        <div className="accordion-body">
                          <div className="table-responsive">
                            <table className="table table-striped">
                              <thead>
                                <tr className="bg-danger text-white fw-bold">
                                  <th>COMMERCIAL</th>
                                  <th>MONTANT</th>
                                  <th>REMBOURSEMENT</th>
                                  <th>RESTE</th>
                                  <th className="text-center">DATE ENREGISTREMENT</th>
                                  <th className="text-center">DATE MISE À JOUR</th>
                                  <th className="text-center">VALIDATION/STATUT</th>
                                </tr>
                              </thead>
                              <tbody>
                                {item.data.map((commercial, index) => (
                                  <tr key={index}>
                                    <td>{commercial.NomCommercial}</td>
                                    <td>{parseInt(commercial.Montant).toLocaleString()} FCFA</td>
                                    <td>{parseInt(commercial.Rembourse).toLocaleString()} FCFA</td>
                                    <td>{parseInt(commercial.Reste).toLocaleString()} FCFA</td>
                                    <td className="text-center">{commercial.DateEnregistrement}</td>
                                    <td className="text-center">{commercial.DateDeMiseAJour}</td>
                                    <td className="text-center">{commercial.ValidationDepense}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

           
              </div>

          {/* Footer page */}

          </div>
        </div>
                    
            
              </div>
            </ContentPage>
        </>
    );

}

export default DegradationFondRoulementPage;